import { Comment, AIInverted } from 'blaze-ui/icons/20'
import cx from 'classnames'
import { Counter, CounterSize } from 'components/Counter/Counter'
import { COMMENT_VIEW, LAYER_CHANGES_VIEW, TASKS_VIEW, AI_VIEW } from 'components/DocRightRail/Constants'
import { observer } from 'mobx-react-lite'
import { useArticleView } from 'providers/ArticleViewProvider/ArticleViewProvider'
import { useState } from 'react'
import { useDocStore } from 'stores/DocStore'
import { ArticleView } from 'types'
import { Collaboration } from '../Collaboration/Collaboration'
import { useCollaborationCount } from '../UseCollaborationCount'
import { useAvailableTabs } from '../useAvailableTabs'
import Styles from './FloatingDocRightRail.module.scss'
import { PanelTrigger } from './PanelTrigger'
import { FloatingDocRightRailProps } from './Types'
import { AIAssistant } from 'components/DocRightRail/screens/AIAssistant/AIAssistant'
import { FocusModeHidden } from 'components/FocusModeHidden/FocusModeHidden'

const FloatingDocRightRail = observer(({ article }: FloatingDocRightRailProps) => {
  const docStore = useDocStore()
  const availableTabs = useAvailableTabs({ article })
  const [anchor, setAnchor] = useState<HTMLDivElement | null>(null)
  const articleView = useArticleView()
  const collaborationCount = useCollaborationCount()

  return (
    <FocusModeHidden>
      <div
        ref={setAnchor}
        className={cx(Styles.root, {
          [Styles.hidden]: docStore.rightRailStore.locked,
        })}
      >
        {availableTabs[AI_VIEW] && docStore.layerId && (
          <PanelTrigger label="AI Assistant" view={AI_VIEW} icon={<AIInverted />} anchor={anchor}>
            <AIAssistant article={article} layerId={docStore.layerId} className={Styles.AIAssistant} />
          </PanelTrigger>
        )}
        {availableTabs[COMMENT_VIEW] && (
          <div className={Styles.collaborationContainer}>
            <PanelTrigger
              label={articleView === ArticleView.Commenting ? 'Comments' : 'Collaboration'}
              view={[COMMENT_VIEW, TASKS_VIEW, LAYER_CHANGES_VIEW]}
              icon={<Comment />}
              anchor={anchor}
            >
              <Collaboration article={article} onClose={() => docStore.rightRailStore.setActiveTab(undefined)} />
            </PanelTrigger>
            {collaborationCount > 0 && (
              <div className={cx(Styles.tabCounter)}>
                <Counter count={collaborationCount} size={CounterSize.xs} className={Styles.counter} />
              </div>
            )}
          </div>
        )}
      </div>
    </FocusModeHidden>
  )
})

export { FloatingDocRightRail }
